/**
 * Sets an SDP as the remote description of the connection.
 * @method setRemoteDescription
 * @param  {RTCSessionDescription} sessionDesc
 */
export default function setRemoteDescription (desc) {
  const { nativePeer, proxyPeer, id, log } = this

  // TODO: SDP pipeline here.
  log.info(`Setting remote description ${desc.type} in ${proxyPeer.signalingState} state.`)
  log.debug(`Setting remote description ${desc.type}:`, desc.sdp)

  /**
   * Scenario: A remote answer SDP is being applied to the Peer, but it does
   *    not have a selected DTLS role yet. This should occur only when the
   *    initial negotiation is being completed.
   * Set the local Peer's DTLS role depending on what the remote Peer
   *    selected. This role will be kept throughout all renegotiations.
   */
  if (!this.dtlsRole && desc.type === 'answer') {
    const dtlsMatch = desc.sdp.match(/a=setup:(\w*?)[\r\n]/)
    if (dtlsMatch) {
      const localRole = dtlsMatch[1] === 'active' ? 'passive' : 'active'
      log.debug(`Selecting DTLS role ${localRole}. Remote Peer selected ${dtlsMatch[1]} DTLS role.`)
      this.dtlsRole = localRole
    }
  }

  // TODO: Update `config.trickleIceMode` to either NONE or FULL (from HALF)
  //    depending on remote support, since HALF is only needed for initial.
  return new Promise((resolve, reject) => {
    nativePeer
      .setRemoteDescription(desc)
      .then(() => {
        log.info('Finished setting remote description.')
        log.debug(`State is now ${proxyPeer.signalingState}.`)
        resolve()
      })
      .catch(err => {
        log.info('Failed to set remote description.')
        log.debug(`Peer ${id}: ${err}`)
        // Parse native error. Make it more understand and/or
        //    provide a better log about what went wrong.
        reject(err)
      })
  })
}
